import { FlightEvaluationRepository } from '@src/main/modules/reports/flight/domain/flight-evaluation.repository';
import {
  BriefFlightEvaluation,
  EvaluationCriteria,
} from '@src/main/modules/reports/shared/domain/evaluation.interface';

export const findFlightEvaluationsByCriteria = async (
  repository: FlightEvaluationRepository,
  criteria: EvaluationCriteria,
): Promise<{ items: BriefFlightEvaluation[]; total: number }> =>
  await repository.findByCriteria(criteria);
